import { render, staticRenderFns } from "./ViewDocumentVerification.vue?vue&type=template&id=8eb0fc2a&"
import script from "./ViewDocumentVerification.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports